var map = {
	"./ac.svg": 7481,
	"./ad.svg": 8893,
	"./ae.svg": 8458,
	"./af.svg": 3378,
	"./ag.svg": 9233,
	"./ago.svg": 1811,
	"./ai.svg": 58,
	"./al.svg": 8529,
	"./am.svg": 369,
	"./ao.svg": 8609,
	"./aq.svg": 1131,
	"./arg.svg": 2865,
	"./arm.svg": 6023,
	"./as.svg": 2387,
	"./at.svg": 5781,
	"./aus.svg": 4445,
	"./aw.svg": 603,
	"./ax.svg": 3089,
	"./az.svg": 9508,
	"./aze.svg": 550,
	"./ba.svg": 762,
	"./bb.svg": 5086,
	"./bd.svg": 6187,
	"./bdi.svg": 3586,
	"./be.svg": 6958,
	"./ben.svg": 8582,
	"./bf.svg": 3380,
	"./bfa.svg": 974,
	"./bg.svg": 2169,
	"./bgd.svg": 8482,
	"./bh.svg": 1687,
	"./bhs.svg": 5900,
	"./bj.svg": 883,
	"./bl.svg": 5382,
	"./blz.svg": 2346,
	"./bm.svg": 8365,
	"./bol.svg": 4494,
	"./bq.svg": 7252,
	"./bra.svg": 6955,
	"./brb.svg": 8874,
	"./brn.svg": 3566,
	"./bs.svg": 280,
	"./bt.svg": 5305,
	"./btn.svg": 2075,
	"./bv.svg": 6100,
	"./bwa.svg": 8720,
	"./by.svg": 7433,
	"./ca.svg": 1153,
	"./caf.svg": 1753,
	"./cc.svg": 2319,
	"./cefta.svg": 1552,
	"./cf.svg": 4747,
	"./ch.svg": 177,
	"./chl.svg": 9881,
	"./chn.svg": 3243,
	"./ci.svg": 576,
	"./civ.svg": 5295,
	"./ck.svg": 5870,
	"./cmr.svg": 3408,
	"./cn.svg": 1916,
	"./cod.svg": 3895,
	"./cog.svg": 3142,
	"./cok.svg": 8513,
	"./col.svg": 9694,
	"./com.svg": 6293,
	"./cp.svg": 6277,
	"./cpv.svg": 3805,
	"./cri.svg": 3727,
	"./cub.svg": 8735,
	"./cv.svg": 6378,
	"./cw.svg": 6250,
	"./cx.svg": 1479,
	"./cy.svg": 225,
	"./cz.svg": 926,
	"./de.svg": 268,
	"./dg.svg": 6957,
	"./dj.svg": 9352,
	"./dji.svg": 4612,
	"./dk.svg": 4165,
	"./dm.svg": 2308,
	"./dom.svg": 3679,
	"./dz.svg": 4981,
	"./dza.svg": 2740,
	"./ea.svg": 4266,
	"./ecu.svg": 6267,
	"./ee.svg": 358,
	"./egy.svg": 5306,
	"./eh.svg": 2507,
	"./er.svg": 4145,
	"./eri.svg": 645,
	"./es-ct.svg": 2523,
	"./es-ga.svg": 2967,
	"./es.svg": 6632,
	"./eth.svg": 2102,
	"./eu.svg": 2431,
	"./fi.svg": 2759,
	"./fj.svg": 8242,
	"./fji.svg": 4948,
	"./fk.svg": 3962,
	"./fm.svg": 5238,
	"./fo.svg": 6687,
	"./fr.svg": 8610,
	"./fsm.svg": 281,
	"./gab.svg": 8191,
	"./gb-eng.svg": 9888,
	"./gb-nir.svg": 2690,
	"./gb-sct.svg": 5708,
	"./gb-wls.svg": 410,
	"./gb.svg": 7082,
	"./gd.svg": 3446,
	"./ge.svg": 4365,
	"./geo.svg": 7261,
	"./gf.svg": 8553,
	"./gg.svg": 8275,
	"./gha.svg": 123,
	"./gi.svg": 5342,
	"./gin.svg": 9306,
	"./gl.svg": 1388,
	"./gmb.svg": 9139,
	"./gn.svg": 4272,
	"./gnb.svg": 2657,
	"./gnq.svg": 9236,
	"./gp.svg": 3156,
	"./gq.svg": 6983,
	"./gr.svg": 5635,
	"./gs.svg": 1005,
	"./gtm.svg": 4429,
	"./gu.svg": 8877,
	"./guy.svg": 9728,
	"./gw.svg": 5631,
	"./gy.svg": 7474,
	"./hkg.svg": 9830,
	"./hm.svg": 9722,
	"./hnd.svg": 701,
	"./hr.svg": 3004,
	"./ht.svg": 8626,
	"./hti.svg": 872,
	"./hu.svg": 2254,
	"./ic.svg": 1232,
	"./idn.svg": 9656,
	"./ie.svg": 1329,
	"./il.svg": 5570,
	"./im.svg": 9206,
	"./ind.svg": 7417,
	"./io.svg": 7957,
	"./iq.svg": 2179,
	"./ir.svg": 8647,
	"./is.svg": 3749,
	"./it.svg": 4282,
	"./jam.svg": 1841,
	"./je.svg": 5668,
	"./jo.svg": 6881,
	"./jpn.svg": 4952,
	"./kaz.svg": 6530,
	"./ken.svg": 4845,
	"./kg.svg": 3296,
	"./kgz.svg": 418,
	"./khm.svg": 4521,
	"./ki.svg": 89,
	"./kir.svg": 3322,
	"./km.svg": 7314,
	"./kn.svg": 9229,
	"./kor.svg": 800,
	"./kp.svg": 7596,
	"./kw.svg": 1991,
	"./ky.svg": 7430,
	"./lao.svg": 136,
	"./lb.svg": 7929,
	"./lbr.svg": 896,
	"./lby.svg": 6474,
	"./lc.svg": 7128,
	"./lca.svg": 1146,
	"./li.svg": 697,
	"./lk.svg": 2488,
	"./lka.svg": 6431,
	"./lso.svg": 9185,
	"./lt.svg": 9814,
	"./lu.svg": 3371,
	"./lv.svg": 7076,
	"./ly.svg": 5803,
	"./ma.svg": 105,
	"./mar.svg": 504,
	"./mc.svg": 3344,
	"./md.svg": 828,
	"./mdg.svg": 1845,
	"./mdv.svg": 8373,
	"./me.svg": 4809,
	"./mex.svg": 1611,
	"./mf.svg": 1896,
	"./mh.svg": 2138,
	"./mhl.svg": 5492,
	"./mk.svg": 1908,
	"./ml.svg": 3080,
	"./mli.svg": 1520,
	"./mm.svg": 8379,
	"./mmr.svg": 1036,
	"./mn.svg": 2328,
	"./mng.svg": 5415,
	"./mo.svg": 7074,
	"./moz.svg": 5726,
	"./mp.svg": 3861,
	"./mq.svg": 7327,
	"./mr.svg": 1727,
	"./mrt.svg": 3248,
	"./ms.svg": 2274,
	"./mt.svg": 3323,
	"./mu.svg": 556,
	"./mus.svg": 1087,
	"./mv.svg": 1809,
	"./mwi.svg": 1530,
	"./mys.svg": 1850,
	"./nam.svg": 3237,
	"./nc.svg": 1594,
	"./ncl.svg": 7817,
	"./ne.svg": 9957,
	"./ner.svg": 5687,
	"./nf.svg": 9561,
	"./nga.svg": 165,
	"./nic.svg": 2406,
	"./niu.svg": 4508,
	"./nl.svg": 8853,
	"./no.svg": 2298,
	"./npl.svg": 6063,
	"./nr.svg": 6051,
	"./nru.svg": 3564,
	"./nu.svg": 9701,
	"./nzl.svg": 2161,
	"./om.svg": 594,
	"./pak.svg": 6773,
	"./pan.svg": 8785,
	"./per.svg": 7550,
	"./pf.svg": 7512,
	"./pg.svg": 3199,
	"./phl.svg": 7175,
	"./pl.svg": 4151,
	"./plw.svg": 6482,
	"./pm.svg": 333,
	"./pn.svg": 2232,
	"./png.svg": 1023,
	"./pr.svg": 8631,
	"./pry.svg": 5304,
	"./ps.svg": 4919,
	"./pt.svg": 1438,
	"./pw.svg": 1160,
	"./pyf.svg": 4546,
	"./qa.svg": 8243,
	"./re.svg": 3562,
	"./ro.svg": 779,
	"./rs.svg": 4426,
	"./rus.svg": 622,
	"./rwa.svg": 7790,
	"./sa.svg": 5692,
	"./sb.svg": 6791,
	"./sc.svg": 704,
	"./sd.svg": 8253,
	"./sdn.svg": 8391,
	"./se.svg": 3488,
	"./sen.svg": 6874,
	"./sgp.svg": 9130,
	"./sh.svg": 9478,
	"./si.svg": 7754,
	"./sj.svg": 3422,
	"./sk.svg": 3054,
	"./slb.svg": 3511,
	"./sle.svg": 7935,
	"./slv.svg": 4228,
	"./sm.svg": 7577,
	"./so.svg": 9486,
	"./som.svg": 5815,
	"./sr.svg": 2449,
	"./ss.svg": 6803,
	"./ssd.svg": 496,
	"./st.svg": 8708,
	"./stp.svg": 3665,
	"./sur.svg": 4203,
	"./swz.svg": 7592,
	"./sx.svg": 4353,
	"./sy.svg": 4866,
	"./syc.svg": 9230,
	"./ta.svg": 5933,
	"./tc.svg": 602,
	"./tcd.svg": 4579,
	"./tf.svg": 1603,
	"./tgo.svg": 8576,
	"./tha.svg": 8743,
	"./tj.svg": 6146,
	"./tjk.svg": 805,
	"./tk.svg": 1246,
	"./tkm.svg": 8587,
	"./tl.svg": 3409,
	"./tm.svg": 7624,
	"./tn.svg": 5698,
	"./to.svg": 5164,
	"./tto.svg": 2883,
	"./tun.svg": 5095,
	"./tur.svg": 6563,
	"./tuv.svg": 8833,
	"./tv.svg": 3503,
	"./tw.svg": 9064,
	"./tza.svg": 5701,
	"./ua.svg": 2178,
	"./uga.svg": 3683,
	"./um.svg": 5159,
	"./un.svg": 8224,
	"./ury.svg": 3463,
	"./us.svg": 1688,
	"./uz.svg": 6525,
	"./uzb.svg": 9569,
	"./va.svg": 3922,
	"./vc.svg": 3134,
	"./ven.svg": 5883,
	"./vg.svg": 1001,
	"./vi.svg": 5822,
	"./vnm.svg": 1214,
	"./vut.svg": 7725,
	"./wf.svg": 7056,
	"./ws.svg": 7714,
	"./xk.svg": 1250,
	"./xx.svg": 9846,
	"./ye.svg": 7598,
	"./yt.svg": 3391,
	"./zaf.svg": 3008,
	"./zmb.svg": 2263,
	"./zwe.svg": 7873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5999;